var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_329_881)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.2036 6.55403L18.9926 0.343094C18.7729 0.123367 18.4749 0 18.1641 0H5.625C4.97772 0 4.45312 0.524597 4.45312 1.17188V28.8281C4.45312 29.4754 4.97772 30 5.625 30H24.375C25.0223 30 25.5469 29.4754 25.5469 28.8281V7.38281C25.5469 7.07199 25.4235 6.77399 25.2036 6.55403ZM23.2031 27.6562H6.79688V2.34375H17.6786L23.2031 7.86827V27.6562ZM18.3609 14.4999C18.4943 16.4342 17.3511 16.6729 16.5898 18.7342C16.0524 20.1897 13.8544 19.3758 14.3912 17.9224C15.2499 15.5974 16.0799 15.4898 16.0229 14.661C15.9885 14.1641 15.5724 13.7478 15.0753 13.7135C14.4713 13.6723 13.9746 14.1458 13.9746 14.7363C13.9746 15.3836 13.45 15.9082 12.8027 15.9082C12.1555 15.9082 11.6309 15.3836 11.6309 14.7363C11.6309 12.792 13.2804 11.2395 15.2364 11.3754C16.9029 11.4903 18.246 12.8334 18.3609 14.4999ZM16.1719 21.3281C16.1719 21.9754 15.6473 22.5 15 22.5C14.3527 22.5 13.8281 21.9754 13.8281 21.3281C13.8281 20.6808 14.3527 20.1562 15 20.1562C15.6473 20.1562 16.1719 20.6808 16.1719 21.3281Z",
    fill: "#664EF9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_329_881"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.166aa75069c433616d5a88927db33d83.svg";
export { ForwardRef as ReactComponent };